/**
 * To reduce scrolling for embedded iframe on third party websites
 */
const getIsMobileCompressed = (iframeHost?: string) => {
  return (
    iframeHost?.includes('bankrate.com') ||
    iframeHost?.includes('moneywise.com') ||
    false
  );
};

export default getIsMobileCompressed;
